import { useAuth } from "context/AuthContext";
import { userRoute } from "pages/user/user.routes";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ClassCarousel } from "ui/base/class/ClassCarousel";
import { mediaSizes, maxContainerWidth, themeColor } from "ui/theme";

const OPTIONS = { align: "start", dragFree: true, duration: 40 };
const SLIDES = Array.from({ length: 10 });

export const PopularClasses = ({ popularClasses }) => {
  const { userData } = useAuth();
  const navigate = useNavigate();

  const classes = popularClasses?.filter((item) => item.user?.id !== userData?.id);

  return (
    <Container>
      {/*<Title>Learn A New Thing Today!</Title>*/}
      <CarouselContainer>
        <ClassCarousel
          title="Popular Classes"
          slides={classes || SLIDES}
          options={OPTIONS}
          onSlideClick={(id) => navigate(userRoute.classDetail + id)}
        />
      </CarouselContainer>
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  width: 100%;
  --carousel-controls-pr: 1rem;

  @media (width >= ${mediaSizes.md}) {
    --carousel-controls-pr: calc(2rem + max(0px, (100vw - ${maxContainerWidth}) / 2));
  }

  //@media (min-width: 768px) {
  //  grid-template-columns: 242px 1fr;
  //  place-items: center;
  //}
`;

const Title = styled.p`
  font-size: 31px;
  line-height: 38px;
  font-weight: 700;
  text-align: left;
  gap: 10px;
  color: ${themeColor("txt")};
  @media (min-width: 768px) {
    font-size: 62px;
    line-height: 76px;
  }
`;

const CarouselContainer = styled.div`
  max-width: 100%;
  overflow: hidden;
`;
